import { useState, useEffect, useContext, createContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useRemote, useStorage } from '../../../Utils/Utils';
import { BannerContext } from '../../../InternalApiApp';
import Page, { PageContentBodyGrid } from '../../Shared/Page/Page';
import PageGridItem from '../../Shared/Page/PageGridItem';
import PageGridDivider from '../../Shared/Page/PageGridDivider';
import ActionButtonsBanner from '../../Shared/Banner/ActionButtonsBanner';
import LoadingIcon from '../../../components/LoadingIcon';
import { Route, Switch, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import PortfolioManagerPageGeneral from './PortfolioManagerPageGeneral';
import PageContentToggle from '../../../components/Menus/PageContentToggle';
import { toastDanger, toastSuccess } from '../../../components/popups/Toast';


export const PortfolioManagerContext = createContext();

/**
 * Note that this is in reality a generic Portfolio Group page, not specifically managers.  Called ManagerPage for CFS expediency.
 */

const PortfolioManagerPage = ({ }) => {
	const remote = useRemote();
	const storage = useStorage()
	const history = useHistory()
	const location = useLocation()
	const { id } = useParams()


	const [config, setConfig] = useState(null)
	const [originalManager, setOriginalManager] = useState(null)
	const [manager, setManager] = useState(null)
	const [editMode, setEditMode] = useState(false)
	const [list, setList] = useState([])
	const [searchTerm, setSearchTerm] = useState("")
	const [loading, setLoading] = useState(true)
	const [selectedTab, setSelectedTab] = useState('General')
	const [groupName, setGroupName] = useState("")
	const [actualGroup, setActualGroup] = useState(null)

	const linkArray = location.pathname.split("/")
	const linkStem = selectedTab == "General" ? linkArray.join('/') : linkArray.slice(0, linkArray.length - 1).join("/")
	const tabName = linkArray[3] ? linkArray[3].charAt(0).toUpperCase() + linkArray[3].slice(1) : "";

	const { setBannerBreadCrumbs } = useContext(BannerContext);

	useEffect(() => {
		remote.get(`funds/portfolio/group/${id}/static-data`).then((resp) => {
			storage.getOrFetch(`funds/funds/groupings/${id}`).then(grouping => {
				setGroupName(grouping.groupingName);
				remote.get(`funds/portfolio/grouping/${grouping.groupingId}/config`).then(res => setConfig(res))
				const foundManager = grouping.groups.find(m => m.groupId === +id)
				setActualGroup(foundManager);
				setBannerBreadCrumbs({
					tab: tabName,
					param1: { name: foundManager.groupName, id: id }
				})
				storage.getOrFetch(`funds/funds2`).then(portfolios => {
					const filteredPortfolios = portfolios.filter(p => foundManager.funds.includes(p.id))
					setList(filteredPortfolios)
					setManager(resp)
					setOriginalManager(resp)
				}).then(() => setLoading(false))
			})
		})
	}, [id])

	function saveEdits() {
		remote.post(`funds/portfolio/group/${id}/static-data`, manager).then((resp) => {
			setEditMode(false)
			setOriginalManager(resp)
			setManager(resp)
			toastSuccess("Changes saved")
		}).catch((err) => {
			toastDanger("Could not save changes")
		})
	}

	function cancelEdits() {
		setManager(originalManager)
		setEditMode(false)
	}


	function changeTab(string) {
		if (string === "General") {
			return history.push(linkStem + ``)
		} else if (string === "Footnotes") {
			return history.push(linkStem + `/footnotes`)
		}
	}

	if (!manager) return (
		<Page noBanner>
			<PageContentBodyGrid id="fund-page" gridColCount="12" subGrid paddingBottom="2.5rem">
				<PageGridItem gap='l' direction='col' col="1 / span 12" >
					<LoadingIcon centered />
				</PageGridItem>
			</PageContentBodyGrid>
		</Page>
	)

	const labels = [
		{ label: "General", active: selectedTab === "General", onClick: () => changeTab("General") }
	]

	return (
		<Page noBanner noOverflownY >
			<PageContentBodyGrid rowGap="none" gridColCount="12" subGrid paddingBottom="2.5rem">
				<PageGridItem gap='l' direction='col' col="1 / span 12" >
					<ActionButtonsBanner
						className="pt-l"
						hideBackButton
						editMode={editMode}
						edit={{ onClick: () => setEditMode(true) }}
						duplicate={{ disabled: true }}
						remove={{ disabled: true }}
						cancel={{ onClick: () => { cancelEdits() } }}
						save={{ onClick: () => { saveEdits() } }}
					/>
					<PageGridDivider />
				</PageGridItem>
				<PageGridItem gap='m' direction='col' col="1 / span 12" className="mt-m" >
					<PageContentToggle style={{ overflowX: 'auto', scrollbarWidth: 'none' }} labels={labels} />
					<PageGridDivider />
				</PageGridItem>
				<PageGridItem direction='col' col="1 / span 12" style={{ overflowY: 'auto', height: "calc(100vh - 20.75rem)", paddingTop: "1.5rem" }}>
					<PageContentBodyGrid gridColCount="12" subGrid>
						<PortfolioManagerContext.Provider
							value={{
								config,
								setConfig,
								originalManager,
								setOriginalManager,
								staticData: manager,
								setStaticData: setManager,
								editMode,
								setEditMode,
								list,
								setList,
								searchTerm,
								setSearchTerm,
								loading,
								setLoading,
								groupName,
								id, 
								actualGroup
							}}
						>
							<Switch >
								<Route exact path={linkStem} render={() => <PortfolioManagerPageGeneral />} />
							</Switch>
						</PortfolioManagerContext.Provider>
					</PageContentBodyGrid>
				</PageGridItem>
			</PageContentBodyGrid >
		</Page >
	);
}

export default PortfolioManagerPage;